import { render } from "./BecomeAPilot.vue?vue&type=template&id=8532d8fe&scoped=true"
import script from "./BecomeAPilot.vue?vue&type=script&lang=js"
export * from "./BecomeAPilot.vue?vue&type=script&lang=js"

import "./BecomeAPilot.vue?vue&type=style&index=0&id=8532d8fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8532d8fe"]])

export default __exports__